import module from '@app/sesion/module'

module.config(($stateProvider) => {
  $stateProvider.state('sesion.reestablecer', {
    url: '/reestablecer',
    data: {title: 'Reestablecer contraseña'},
    component: 'appSesionReestablecer',
  })
})



// WEBPACK FOOTER //
// ./src/app/sesion/routes/sesion/reestablecer.js